module.exports = __webpack_public_path__ + "media/images/powered_by_sh_140x32w-123eefb52a6b3f63271ac3f01d58dd5f.png";